export default function SpecialistCard({ data }) {
  return (
    <div className='w-full max-w-[18.75rem] select-none'>
      <div className='flex flex-col items-center'>
        <img
          src={data?.image || "global_Images/user.png"}
          alt={data?.fullName}
          className='w-[200px] h-[200px] object-fill rounded-t-md'
        />

        <div className='w-full flex'>
          <div className='flex bg-secondary w-full h-12 rounded-custom-20 justify-end'>
            <p className='flex items-center px-4 truncate'>{data?.fullName} </p>
            <div className='flex justify-center items-center bg-primary min-w-[30%] rounded-custom-20 text-primary4'>
              <p className='p-4'>{data?.specialization}</p>
            </div>
          </div>
          <div></div>
        </div>
      </div>
    </div>
  );
}
